import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { UserDto } from '../model/user.dto';
import { GetEmployeeResponse } from './../../../api/safety-system/models/get-employee-response';
import { AuthService } from "src/api/safety-system/services";
import { Router } from "@angular/router";
@Injectable({
    providedIn: 'root',
})
export class UserHelper {
    private user: UserDto = {} as UserDto;
    public userSubject: BehaviorSubject<UserDto> = new BehaviorSubject<UserDto>(this.user);
    constructor(private authServie: AuthService, private router: Router) {

    }

    public initUser() {
        const token = this.getToken();
        if (token) {
            this.authServie.AuthGetUserFromAccessToken(token).subscribe((response: GetEmployeeResponse) => {
                this.userSubject.next(response);
            })
        } else {
            this.router.navigate([''])
        }
    }

    getToken(): string | null {
        return localStorage.getItem('accessToken');
    }

    isAuthenticated(): boolean {
        const token = this.getToken();
        // Check if token is present and not expired
        return !!token; // Implement your token verification logic here
    }
}
